module.exports = __webpack_public_path__ + "img/Certificate_12.e10a64dc.jpg";